import { useState } from 'react'

function useLocalStorage<T>(key: string, initialValue: T) {
  const [value, setValue] = useState<T>(() => {
    const storedValue = localStorage.getItem(key)
    return storedValue ? JSON.parse(storedValue) : initialValue
  })

  const setLocalStorageValue = (newValue: T) => {
    setValue(newValue)
    localStorage.setItem(key, JSON.stringify(newValue))
  }

  const removeLocalStorageValue = () => {
    setValue(initialValue)
    localStorage.removeItem(key)
  }

  return {
    value,
    setLocalStorageValue,
    removeLocalStorageValue,
  }
}

export default useLocalStorage
